module.exports = __webpack_public_path__ + "img/FCFF.82008e68.svg";